import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PwaInstaller } from '../../components/security/PwaInstaller';
import { useAuthStore } from '../../store/authStore';

export function InstallPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isLoading: authLoading, isAuthenticated, user } = useAuthStore();
  const redirect = searchParams.get('redirect') || '/';

  // Verificar se está no PWA (modo standalone)
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true ||
    window.location.protocol === 'capacitor:' ||
    !!(window as any).Capacitor;

  const token = localStorage.getItem('ac_token') || sessionStorage.getItem('ac_token') || '';
  const hasSession = !!token || isAuthenticated || !!user;

  useEffect(() => {
    const skippedPwaInstall = localStorage.getItem('ac_skip_pwa_install') === 'true';
    if (skippedPwaInstall || isStandalone) {
      navigate(redirect, { replace: true });
    }
  }, [isStandalone, redirect, navigate]);

  const handleSuccess = () => {
    const target = hasSession ? redirect : '/login';
    navigate(target, { replace: true });
  };

  const handleSkip = () => {
    localStorage.setItem('ac_skip_pwa_install', 'true');
    const target = hasSession ? redirect : '/login';
    navigate(target, { replace: true });
  };

  if (isStandalone || localStorage.getItem('ac_skip_pwa_install') === 'true') return null;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'transparent',
      color: '#e2e8f0',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      {/* Header com logo e ícone de marca */}
      <header style={{
        width: '100%',
        padding: '1.25rem 1.5rem 0.75rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
        zIndex: 2,
        background: 'rgba(15, 10, 37, 0)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        boxSizing: 'border-box',
      }}>
        <img
          src="/icons/logo-pwa.svg"
          alt="Aluno Conectado"
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            objectFit: 'contain'
          }}
        />
        <span style={{ fontSize: '1.3rem', fontWeight: 800, letterSpacing: '-0.01em' }}>
          <span style={{ color: '#ffffff' }}>Aluno </span>
          <span style={{ color: '#a855f7' }}>Conectado</span>
        </span>
      </header>

      {/* Conteúdo centralizado */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        width: '100%',
        boxSizing: 'border-box',
      }}>
        <div style={{ width: '100%', maxWidth: 500, zIndex: 1 }}>
          <PwaInstaller
            onSuccess={handleSuccess}
            onSkip={handleSkip}
            showAccountCard={false}
          />
        </div>
      </div>

      <style>{`
        @keyframes pan-bg {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>
    </div>
  );
}
